let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4o9NW")).then(() => parcelRequire('fBLTM'));